import {getFormattedLocation} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../../commons/hooks/dates'
import {useAppSelector} from '../../../../hooks/runtime'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {getEvent} from '../../../../selectors/event'
import {ShortDateLocationProps} from './interfaces'
import s from './short-date-location.scss'

const separator = '  |  '

export const ShortDateLocation = ({mobile}: ShortDateLocationProps) => {
  const {
    allBreakpoints: {isShortDateLocationVisible},
  } = useVisibilityStyles()
  const event = useAppSelector(getEvent)
  const {shortStartDate} = useEventDateInformation(event.id)

  return isShortDateLocationVisible() ? (
    <div
      className={classNames(s.container, {
        [s.mobile]: mobile,
      })}
      data-hook={DH.headerShortDateLocation}
    >
      <p className={s.date} data-hook={DH.headerShortDate}>
        {shortStartDate}
      </p>
      <span className={s.separator}>{separator}</span>
      <p className={s.location} data-hook={DH.headerShortLocation}>
        {getFormattedLocation(event)}
      </p>
    </div>
  ) : null
}
